import { CalendarClock } from "lucide-react";
import { Card } from "@/components/app/StatusBadge";
import { useApp } from "@/lib/i18n";

export const fmtDate = (d, lang) => (d ? new Date(typeof d === "number" ? d * 1000 : d).toLocaleDateString(lang === "en" ? "en-MY" : "ms-MY", { day: "numeric", month: "short", year: "numeric" }) : "-");

export const subLabel = (sub, L, lang) => {
  if (!sub || !sub.source) return null;
  if (sub.source === "admin") return L("Diberikan oleh pentadbir (tiada caj automatik)", "Assigned by admin (no automatic billing)");
  const via = sub.source === "paypal" ? "PayPal" : L("Kad (Stripe)", "Card (Stripe)");
  const cyc = sub.cycle === "yearly" ? L("Tahunan", "Yearly") : L("Bulanan", "Monthly");
  const end = fmtDate(sub.current_period_end, lang);
  return `${cyc} · ${via} · ${sub.cancel_at_period_end ? L(`tamat pada ${end}`, `ends on ${end}`) : L(`diperbaharui pada ${end}`, `renews on ${end}`)}`;
};

export const CycleInfo = ({ u, sub }) => {
  const { L, lang } = useApp();
  if (u.plan.key === "free") return null;
  const s = subLabel(sub, L, lang);
  return (
    <Card className="mt-4 flex flex-wrap items-start gap-4 p-5" data-testid="cycle-info">
      <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-violet-50 text-violet-700"><CalendarClock size={20} /></span>
      <div className="min-w-0 flex-1 space-y-1 text-sm">
        <p className="font-semibold text-slate-900">{L("Tempoh langganan", "Subscription period")}</p>
        <p className="text-slate-600" data-testid="cycle-range">{L("Kitaran kuota semasa", "Current quota cycle")}: <b>{fmtDate(u.cycle_start, lang)} – {fmtDate(u.cycle_end, lang)}</b></p>
        <p className="text-slate-600" data-testid="cycle-reset">{L("Kuota minit, dokumen & soalan AI ditetapkan semula pada", "Minutes, documents & AI questions reset on")} <b>{fmtDate(u.cycle_end, lang)}</b>{L(", mengikut tarikh langganan anda bermula.", ", based on the date your subscription started.")}</p>
        {s && <p className="text-slate-600" data-testid="cycle-subscription">{L("Langganan", "Subscription")}: <b>{s}</b></p>}
      </div>
    </Card>
  );
};
